import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleWare from '@redux-saga/core';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './styles/index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import AuthContextProvider from './contexts/AuthContextProvider';
import partyActions from './reducers/partyReducers';
import { watchGetAllPartyGoersRequest } from './sagas/partySagas';
import CacheContextProvider from './contexts/CacheContextProvider';
import ErrorBoundary from './components/ErrorBoundary';
import { NotificationProvider } from './contexts/NotificationContext';

const sagaMiddleware = createSagaMiddleWare();

const store = configureStore({
  reducer: partyActions.reducer,
  middleware: [sagaMiddleware]
});

sagaMiddleware.run(watchGetAllPartyGoersRequest);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <NotificationProvider>
      <GoogleOAuthProvider clientId='907723160041-fvv4adb8qh144t04s68knq8nmnktllu4.apps.googleusercontent.com'>
        <AuthContextProvider>
          <CacheContextProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </CacheContextProvider>
        </AuthContextProvider>
      </GoogleOAuthProvider>
    </NotificationProvider>
  </ErrorBoundary>
);

reportWebVitals();
